import { render, staticRenderFns } from "./IgnitionReportDetails.vue?vue&type=template&id=54b5b89d&scoped=true&"
import script from "./IgnitionReportDetails.vue?vue&type=script&lang=js&"
export * from "./IgnitionReportDetails.vue?vue&type=script&lang=js&"
import style0 from "./IgnitionReportDetails.vue?vue&type=style&index=0&id=54b5b89d&lang=scss&scoped=true&"
import style1 from "./IgnitionReportDetails.vue?vue&type=style&index=1&id=54b5b89d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b5b89d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54b5b89d')) {
      api.createRecord('54b5b89d', component.options)
    } else {
      api.reload('54b5b89d', component.options)
    }
    module.hot.accept("./IgnitionReportDetails.vue?vue&type=template&id=54b5b89d&scoped=true&", function () {
      api.rerender('54b5b89d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Reports/IgnitionReportDetails.vue"
export default component.exports